module.exports = __webpack_public_path__ + "static/media/09(3).b24c5330.jpg";